import { t, Trans } from "@lingui/macro";
import { Modal } from "antd";
import React from "react";
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { getMsgType, getMsgTypeCapitalized } from "../../../helper";
import { deleteAutosaveStorage } from "../../../../LocalStorage/helpers/AutosaveTransactions/deleteStorage";
import { history } from "../../../../store";
import { ExclamationCircleFilled } from "@ant-design/icons";

// Show this modal if an autosaved copy of the transaction is detected in local storage,
// and user is in other NEW actions, eg Pay, Duplicate etc.
export function showWillOverrideAutosaveDataPromise(transactionType, autosaveModalRef, lastSaved, action) {
    return new Promise(resolve => {
        // eslint-disable-next-line no-param-reassign
        autosaveModalRef.current = Modal.confirm();

        // Set the resolve function, to be called when onPageChange in each txn's new.js
        // eslint-disable-next-line no-param-reassign
        autosaveModalRef.current.resolve = resolve;

        autosaveModalRef.current.update({
            title: t`Autosaved ${getMsgTypeCapitalized(transactionType)} Detected`,
            content: (
                <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
                    <div>
                        <Trans>
                            {/* {`An autosaved ${getMsgType(transactionType)} is detected.
                            The saved data ${<strong>will be overriden</strong>} if you proceed.`} */}
                            {`Proceeding with ${action} will replace the autosaved ${getMsgType(transactionType)} data from 
                            ${<span style={{color: "grey"}}>{lastSaved}</span>}. `}
                        </Trans>
                    </div>
                    <br />
                    <div>
                        <Trans>
                            Are you sure you want to
                            <strong>{` proceed with ${action}`}</strong>
                            ?
                        </Trans>
                    </div>
                    <br />
                </I18nProvider>
            ),
            onOk() {
                deleteAutosaveStorage(transactionType); // wipe previously saved data
                resolve(true);
            },
            onCancel() {
                history.goBack(); // go back to previous page if user doesn't want to proceed
                resolve(false);
            },
            icon: <ExclamationCircleFilled style={{color: "#1677ff"}} />,
            okText: t`OK`,
            cancelText: t`Go back`,
            keyboard: false,
        });
    });
}
